export default () => {
  console.log(process.env)
  return process.env.REACT_APP_API;
}